var selectFooter = document.querySelector('.q10__footer');
selectFooter.style = 'position:sticky;'
var mainContentContainer = document.querySelector('.q10__content');
// console.log(mainContentContainer.offsetHeight)

var responsive1025 = window.matchMedia("(min-width: 1025px)")
var responsive1500 = window.matchMedia("(min-width: 1500px)")
var responsive1800 = window.matchMedia("(min-width: 1800px)")
var responsive2400 = window.matchMedia("(min-width: 2400px)")

if(mainContentContainer.offsetHeight < 1000 && responsive2400.matches){
        selectFooter.style = 'position:absolute;'
    } else if (mainContentContainer.offsetHeight < 700 && responsive1800.matches){
        selectFooter.style = 'position:absolute;'
    } else if (mainContentContainer.offsetHeight < 500 && responsive1500.matches){
        selectFooter.style = 'position:absolute;'
    } else if (mainContentContainer.offsetHeight < 300 && responsive1025.matches){
        selectFooter.style = 'position:absolute;'
    } 
    
    else {
        selectFooter.style = 'position:sticky;'
    }

function setFooterType(){
    if(mainContentContainer.offsetHeight < 1000 && responsive2400.matches){
        selectFooter.style = 'position:absolute;'
    } else if (mainContentContainer.offsetHeight < 700 && responsive1800.matches){
        selectFooter.style = 'position:absolute;'
    } else if (mainContentContainer.offsetHeight < 500 && responsive1500.matches){
        selectFooter.style = 'position:absolute;'
    } else if (mainContentContainer.offsetHeight < 300 && responsive1025.matches){
        selectFooter.style = 'position:absolute;'
    } 
    else {
        selectFooter.style = 'position:sticky;'
    }
}
window.addEventListener('resize', setFooterType);

